import React, { CSSProperties, ReactNode } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import styles from './DeleteClassificationsDialog.module.css';
import { useDeleteClassificationListMutation } from '../../../generated/graphql';

type DeleteClassificationsDialogProps = {
    onClose: () => void,
    ids: string[],
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const DeleteClassificationsDialog = (props: DeleteClassificationsDialogProps) => {
    const { style, visible, ids, onClose } = props;
    const [deleteClassifications, deleteClassificationsResult] = useDeleteClassificationListMutation({
        variables: {
            ids: ids
        }
    });

    const handleOnYesClick = () => {
        deleteClassifications()
            .then(res => onClose())
            .catch(err => { });
    };

    return (
        <DialogBase
            title="Delete Classifications"
            type="YesNo"
            visible={visible}
            onClose={onClose}
            className={styles.DeleteClassificationsDialog}
            style={style}
            data-testid="DeleteClassificationsDialog"
            onYesClick={handleOnYesClick}
            isLoading={deleteClassificationsResult.loading}>
            <p style={{ color: "var(--text-secondary)" }}>Are you sure you want to delete these classifications?</p>
        </DialogBase>
    );
};

export default DeleteClassificationsDialog;